<template>
    <div class="structure-box">
        <HeaderNav
            header-title="按趋势"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <div class="structure-box-content">
            <!-- 图表1 -->
            <div id="main"></div>
            <div class="zhanwei"></div>
            <!-- 图表2 -->
            <div id="mainOne"></div>
            <div class="zhanwei" style="margin-bottom:30rpx"></div>
        </div>
    </div>
</template>
<script>
import { HeaderNav } from '@/components/';
import { Dialog } from 'vant';
export default {
    components: {
        HeaderNav,
    },
    data() {
        return {
            selectTimeYear: '',
            selectTimeMonth: '',
            orgId: '',
            // 图表1相关
            chartMonthOne: [],
            chartSalesConcrete: [],
            chartPriceConcrete: [],
            // 图表2相关
            chartOrgName: [],
            chartMonthTwo: [],
            seriesData: [],
            lineColoeArr: ['#FA8436', '#3DB7AA', '#5588F1', '#C64FDF'],
        };
    },
    mounted() {
        localStorage.setItem('objTimeYear', this.$route.query.year);
        localStorage.setItem('objTimeMonth', this.$route.query.month);
        this.selectTimeYear = this.$route.query.year;
        this.selectTimeMonth = this.$route.query.month;
        const value = this.$store.state.orgData[0].value;
        this.orgId = value;
        this.getSalesMonth();
        this.getSalesOrgMonth();
    },
    methods: {
        // 量价趋势分析
        getSalesMonth() {
            this.$axios
                .get(`/interfaceApi/report/SaleManager/get_sales_month/${this.selectTimeYear}/${this.selectTimeMonth}/${this.orgId}`)
                // .get('/interfaceApi/report/SaleManager/get_sales_month/2019/OT000001')
                .then(res => {
                    if (res) {
                        res.forEach(item => {
                            const arr = item.sales_concrete.toFixed(2) || 0;
                            const brr = item.price_concrete.toFixed(2) || 0;
                            this.chartMonthOne.push(item.month + '月');
                            // this.chartSalesConcrete.push(item.sales_concrete);
                            // this.chartPriceConcrete.push(item.price_concrete);
                            this.chartSalesConcrete.push(arr);
                            this.chartPriceConcrete.push(brr);
                        });
                        // eslint-disable-next-line max-len
                        Promise.all([this.chartMonthOne, this.chartSalesConcrete, this.chartPriceConcrete]).then(() => {
                            this.trendChartOne();
                        }).catch(error => {
                            Dialog({ message: error.Errorcode.Message });
                        });
                    }
                })
                .catch(error => {
                    Dialog({ message: error.Errorcode.Message });
                });
        },
        // 区域售价分析
        getSalesOrgMonth() {
            this.$axios
                .get(`/interfaceApi/report/SaleManager/get_sales_org_month/${this.selectTimeYear}/${this.selectTimeMonth}/${this.orgId}`)
                // .get('/interfaceApi/report/SaleManager/get_sales_org_month/2019/OT000001')
                .then(res => {
                    if (res) {
                        let aaa = 0;
                        res.forEach((item, index) => {
                            const arr = [];
                            const brr = [];
                            const crr = [];
                            this.chartOrgName.push(item.org_name);
                            let aFixed;
                            item.data.forEach(datas => {
                                aFixed = datas.price_concrete.toFixed(2);
                                arr.push(datas.month + '月');
                                brr.push(datas.sales_concrete || 0);
                                crr.push(aFixed || 0);
                            });
                            this.chartMonthTwo.push(arr || 0);
                            this.seriesData.push({
                                name: item.org_name,
                                type: 'line',
                                stack: '总量' + aaa++,
                                data: crr,
                                color: this.lineColoeArr[index],
                            });
                        });
                        setTimeout(() => {
                            this.trendChartTwo();
                        }, 100);
                    }
                })
                .catch(error => {
                    Dialog({ message: error.Errorcode.Message });
                });
        },
        // 图表1
        trendChartOne() {
            const myChart = this.$echarts.init(document.getElementById('main'));
            // 指定图表的配置项和数据
            const option = {
                title: {
                    x: 'left',
                    text: '本年累计量价趋势分析',
                },
                tooltip: {
                    trigger: 'axis',
                    // backgroundColor: '#EAEFFC'
                },
                legend: {
                    padding: 35,
                    data: ['销量', '售价'],
                    itemWidth: 20, // 图例图形宽度
                    itemHeight: 10,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.chartMonthOne,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 10, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        boundaryGap: true,
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '销量(万方)',
                        axisLabel: {
                            formatter: '{value}',
                            fontSize: 10, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                    {
                        type: 'value',
                        name: '售价(元/方)',
                        axisLabel: {
                            fontSize: 10, // 字体大小
                            formatter: '{value}',
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                series: [
                    {
                        name: '销量',
                        type: 'bar',
                        data: this.chartSalesConcrete,
                        color: '#5588F1',
                        barWidth: 10, // 柱图宽度
                    },
                    {
                        name: '售价',
                        type: 'line',
                        yAxisIndex: 1,
                        data: this.chartPriceConcrete,
                        color: '#FA8436',
                    },
                ],
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option, true);
        },
        trendChartTwo() {
            // 基于准备好的dom，初始化echarts实例
            const myCharts = this.$echarts.init(document.getElementById('mainOne'));
            // 指定图表的配置项和数据
            const option = {
                title: {
                    x: 'left',
                    text: '本年累计区域售价横比',
                },
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    x: 200,
                    y: 0,
                    orient: 'vertical',
                    data: this.chartOrgName,
                    itemWidth: 25, // 图例图形宽度
                    itemHeight: 10,
                    // {
                    //     x: 0,
                    //     y: 100,
                    //     orient: 'horizontal',
                    //     data: '淮海运营区',
                    //     itemWidth: 25, // 图例图形宽度
                    //     itemHeight: 10,
                    // },
                    // {
                    //     x: 50,
                    //     y: 110,
                    //     orient: 'horizontal',
                    //     data: '河南运营区',
                    //     itemWidth: 25, // 图例图形宽度
                    //     itemHeight: 10,
                    // },
                    // {
                    //     x: 100,
                    //     y: 120,
                    //     orient: 'horizontal',
                    //     data: '河北运营区',
                    //     itemWidth: 25, // 图例图形宽度
                    //     itemHeight: 10,
                    // },
                    // {
                    //     x: 150,
                    //     y: 130,
                    //     orient: 'horizontal',
                    //     data: '北京新航',
                    //     itemWidth: 25, // 图例图形宽度
                    //     itemHeight: 10,
                    // },
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.chartMonthTwo[0],
                    // 设置间隔
                    axisLabel: {
                        interval: 0,
                        fontSize: 10, // 字体大小
                    },
                    // 设置边框样式
                    axisLine: {
                        lineStyle: {
                            color: '#979EA7',
                        },
                    },
                    splitLine: { show: false },
                    axisTick: { show: false },
                },
                yAxis: {
                    type: 'value',
                    splitLine: { show: false },
                    axisTick: { show: false },
                    name: '售价(元/方)',
                    // 设置边框样式
                    axisLine: {
                        lineStyle: {
                            color: '#979EA7',
                        },
                    },
                    // 设置间隔
                    axisLabel: {
                        fontSize: 10, // 字体大小
                    },
                },
                series: this.seriesData,
            };
            // 使用刚指定的配置项和数据显示图表。
            myCharts.setOption(option, true);
        },
    },
};
</script>

<style lang="stylus" scoped>
.structure-box-content
    overflow-y scroll
    padding-top 44rpx
    height 100%
.zhanwei
    width 100%
    height 15rpx
    background #F0F0F0
.title-one
    padding 15rpx 5% 10rpx
#main
    width 90%
    height 300rpx
    margin 15rpx 5% 0
#mainOne
    width 90%
    height 300rpx
    margin 15rpx 5% 0
</style>